import Repository from './Repository';

class CwPluginRepository extends Repository {
	getCompany (company) {
		return this.getWithToken(`/cw-settings/company?company=${company}`);
	}

	storeSettings (form) {
		return this.postWithToken('/cw-settings/settings', form);
	}

	updateSettings (id, form) {
		return this.putWithToken(`/cw-settings/settings/${id}`, form);
	}

	getMonitorErrors () {
		return this.getWithToken('/cw-settings/errors');
	}

	clearError (errorId) {
		return this.putWithToken(`/cw-settings/error-clear/${errorId}`);
	}

	clearSelectedErrors (errors) {
		return this.putWithToken('/cw-settings/error-clear/selected', errors);
	}

	clearAllErrors () {
		return this.putWithToken('/cw-settings/error-clear/all');
	}

	ignoreError (errorId) {
		return this.putWithToken(`/cw-settings/error-ignore/${errorId}`);
	}

	ignoreSelectedErrors (errors) {
		return this.putWithToken('/cw-settings/error-ignore/selected', errors);
	}

	ignoreAllErrors () {
		return this.putWithToken('/cw-settings/error-ignore/all');
	}
}

export default new CwPluginRepository();
